/**
 * Панель настроек блока в модальных окнах.
 *
 * Содержит общие элементы управления:
 * - Селект периода (date) через FormManualSelect
 * - Кнопки типа отображения (chart/table/number)
 * - Кнопки типа графика (для chart)
 *
 * Используется в AddBlockModal и EditBlockModal.
 */

import React, { FC } from 'react';

import { FormInstance, Tooltip, Button } from 'antd';

import FormManualSelect from './FormManualSelect';
import ButtonsType from '../../ButtonsType';
import {
  BlockDisplayType,
  displayItems,
  displayTypeButtonsWithoutHeading as displayTypeButtons,
} from '../constants';

// ==================== ТИПЫ ====================

export interface BlockSettingsPanelProps {
  /** Форма Ant Design */
  form: FormInstance;
  /** Текущий тип отображения */
  currentSelect: BlockDisplayType;
  /** Обработчик изменения значения */
  onValueChange: (key: string, value: string) => void;
  /** Кнопки типа отображения (можно переопределить) */
  displayButtons?: typeof displayTypeButtons;
}

// ==================== КОМПОНЕНТ ====================

export const BlockSettingsPanel: FC<BlockSettingsPanelProps> = ({
  form,
  currentSelect,
  onValueChange,
  displayButtons = displayTypeButtons,
}) => {
  return (
    <div
      className="dashboard-params-compact"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        padding: '12px 0',
        marginBottom: '8px',
        flexWrap: 'wrap',
      }}
    >
      {/* Селект периода */}
      {displayItems.map((item, index) => {
        const selectedValue = form.getFieldValue(item.id);
        const selectedOption = item.selectValues.find(
          (el) => el.id === selectedValue
        );

        return (
          <FormManualSelect
            key={index}
            id={item.id}
            name={item.name}
            selectValues={item.selectValues}
            description={item?.description}
            icon={item.icon}
            form={form}
            handleValueChange={onValueChange}
            initialValue={selectedOption ? selectedOption.id : null}
          />
        );
      })}

      {/* Кнопки выбора типа отображения */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <span style={{ color: '#495057', fontSize: '14px' }}>Отображаем:</span>
        <div style={{
          display: 'flex',
          gap: '2px',
          padding: '4px',
          background: '#f0f0f0',
          borderRadius: '8px',
        }}>
          {displayButtons.map((btn) => {
            const isSelected = currentSelect === btn.id;
            return (
              <Tooltip key={btn.id} title={btn.name}>
                <Button
                  type="text"
                  icon={btn.icon}
                  onClick={() => onValueChange('display', btn.id)}
                  className={`display-type-btn ${isSelected ? 'selected' : ''}`}
                />
              </Tooltip>
            );
          })}
        </div>
      </div>

      {/* Тип графика (только для диаграммы) */}
      {currentSelect === 'chart' && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          <span style={{ color: '#495057', fontSize: '14px' }}>Тип графика:</span>
          <ButtonsType />
        </div>
      )}
    </div>
  );
};

export default BlockSettingsPanel;
